(function (angular, app) {
   "use strict";

   // Slider
   angular.module(app.modules.group.name)
      .directive(app.modules.group.directives.grouppicker, GroupPickerDirective);

   GroupPickerDirective.$inject = ["$timeout", "ngDialog"
      , app.modules.common.services.functions
      , app.modules.common.constants.appmessaging
      , app.modules.group.services.groups
      , app.modules.common.constants.appsettings
      , app.modules.common.services.storage
   ];

   function GroupPickerDirective($timeout, ngDialog
       , ggFunctions
       , ggMessaging
       , ggGroupSearchSvc
       , appSettings
       , ggStorage
       ) {

      var ctrl = this;

      return {
         restrict: "A"
         , templateUrl: "app/group/directives/grouppicker.html"
         , scope: {
            callback: "&"
         }
         , link: function (scope, element, attrs) {


            scope.cp = {
               groupId: 0
               , window: ggFunctions.fetchWindowSize()
               , viewType : 1 // 1: all, 2: CreatedBy, 3: Member of
               , defaultView: 1
               , isLoaded: false
               , isProcessing : false
               , isSearch: false
               , Group: {}

               , pickGroup: function () {
                  ngDialog.closeAll();

                  app.Member.Session.pageTemplates.fetch("app/group/directives/grouppicker-modal.html").then(function (template) {
                     if (isCordova && isCordovaReady) {
                        StatusBar.backgroundColorByHexString(app.Branding.hexModal);
                     }

                     var _groupPicker = ngDialog.open({
                        template: template
                        , plain: true
                        , closeByEscape: true
                       , closeByDocument: true
                       , className: "slideup picker group"
                       , scope: scope
                     });

                     _groupPicker.closePromise.then(function () {
                        if (isCordova && isCordovaReady) {
                           StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                        }
                     });
                  });


                  if (scope.cp.defaultView == 2) {
                     scope.cp.dialog.search.byCreator();
                  }
                  if (scope.cp.defaultView == 3) {
                     scope.cp.dialog.search.byMember();
                  }
               
               }

               , dialog : {

                  alert: ""
                  , name: ""
                  , isProcessing: false
                  , selectGroup: function (groupId) {

                     if (groupId) {

                        for (var x = 0; x < scope.cp.dialog.search.results.length; x++) {
                           var group = scope.cp.dialog.search.results[x];

                           if (group.id == groupId) {

                              scope.cp.Group = group.group || group;
                              ngDialog.closeAll();

                              // Reset form
                              scope.cp.dialog.name = "";
                              scope.cp.dialog.search.results = [];

                              scope.callback()(group);

                           }
                        }
                     }
                  }
                  , search: {
                     results: []
                     , type: 1 // 1: Name, 2: Groups I'm in, 3: Groups I'm organizing
                     , fetch: function (form) {

                        var promise;

                        if (scope.cp.dialog.search.type == 1) {
                           promise = ggGroupSearchSvc.search.fetchGroupSearch
                        }
                        if (scope.cp.dialog.search.type == 2) {
                           promise = app.Member.Network.Data.Groups.fetch
                        }
                        if (scope.cp.dialog.search.type == 3) {
                           promise =app.Member.Network.Data.Groups.allmygroups.fetch
                        }

                        scope.cp.dialog.isProcessing = true;
                        promise(form).then(function (data) {

                           if (scope.cp.dialog.search.type == 1){
                              if (data && data.status == "200") {
                                 var results = data.data.value;

                                 if (results) {
                                    scope.cp.dialog.search.results = results;
                                 } else {
                                    scope.cp.dialog.alert = ggMessaging.group.search.noresults;
                                 }
                              }
                           } else {
                              var res = [];
                              var results = data;
                              for (var g = 0; g < results.length; g++) {
                                 if (results[g].group) {
                                     if (scope.cp.dialog.search.type == 3) {
                                         if (!results[g].group.isAdminRestricted || results[g].group.createdBy.id == app.Member.Detail.id) {
                                             res.push(results[g].group);
                                         }
                                     } else {
                                         res.push(results[g].group);
                                     }
                                     
                                 }
                              }
                              results = res;

                              if (data.length > 0) {
                                 scope.cp.dialog.search.results = results;
                              } else {

                                  // There are no groups, so let's create a default group.
                                  return scope.cp.dialog.search.createDefaultGroup();

                                 scope.cp.dialog.alert = ggMessaging.group.search.noresults;
                              }
                           }
                     

                        }, function (error) {
                           scope.cp.dialog.alert = ggMessaging.api.error;
                        }).finally(function () {
                           scope.cp.dialog.isProcessing = false;
                           scope.cp.isSearch = true;
                        });
                     }
                     
                     , byName: function () {
                        var form = {
                           name: scope.cp.dialog.name
                        }
                        if (form.name.length > 3) {
                           scope.cp.dialog.search.type = 1;
                           scope.cp.dialog.search.fetch(form);
                        }


                     }
                     , byMember: function () {
                        scope.cp.dialog.search.type = 2;
                        scope.cp.dialog.name = "Groups I'm in...";
                        scope.cp.dialog.search.fetch(true);
                     }
                     , byCreator: function () {
                        scope.cp.dialog.search.type = 3;
                        scope.cp.dialog.name = "Groups I'm organizing";
                        scope.cp.dialog.search.fetch(true);
                     }
                      , createDefaultGroup: function () {
                          var myName = app.Member.Detail.firstName || "";
                          myName += " ";
                          myName += app.Member.Detail.lastName || "";

                          if (myName.trim() == "") {
                              myName = "My";
                          } else {
                              myName += "'s"
                          }
                          var form = {
                              groupName: myName + " Group"
                             , groupId: 0
                             , isPrivate: false
                             , groupTypeId: 1 // 1, 2 --- Group, Club
                             , isActive: true // 1, 2, 3 -- Active, Inactive, Archived
                             , themeId: "1"
                             , handicapType: "Official"
                             , isUserHandicapUpdateAllowed: false
                             , isAdminRestricted: false
                          }
                          return ggGroupSearchSvc.setup.insertGroup(form).then(function (data) {
                              if (data) {

                                 // My groups aren't current
                                 ggStorage.set(ggStorage.keys.groups.my.isCurrent, false);
                                 ggStorage.set(ggStorage.keys.groups.organizer.isCurrent, false);

                                 var res = {
                                     id: data.data.id
                                     , name: form.groupName
                                     , createdBy: {
                                         firstName: app.Member.Detail.firstName
                                         , lastName: app.Member.Detail.lastName
                                     }
                                     , isPrivate: false
                                     , groupTypeId: 1 // 1, 2 --- Group, Club
                                     , isActive: true // 1, 2, 3 -- Active, Inactive, Archived
                                     , themeId: "1"
                                     , handicapType: "Official"
                                     , isUserHandicapUpdateAllowed: false
                                     , isAdminRestricted: false
                                 }

                                 scope.cp.dialog.search.results.push(res);

                                  // This should be auto trigger in API
                                 return app.Member.Authenticate.RefreshToken();

                              }
                          }, function (error) {
                              ggFunctions.toggleProcessing(false);
                              $scope.InlineAlert.fail("Error", "There was an error inserting the group.");
                          }).finally(function () {
                              ggFunctions.toggleProcessing(false);
                          });
                      }

                  }
                  , newGroup: function () {
                     ngDialog.closeAll();
                     ggFunctions.goToPage(app.modules.group.routes.setup.path);
                  }
               }
            }


            var loadOptions = function (objStr, isUpdate) {
               if (objStr) {
                  var obj = JSON.parse(objStr);
                  if (obj) {
                     
                     // View of Modal
                     if (obj.viewType) {
                        scope.cp.viewType = Number(obj.viewType);
                     }
                     if (obj.defaultView) {
                        scope.cp.defaultView = Number(obj.defaultView);
                     }


                     // Was a group object provided?
                     if (obj.groupObj) {
                        scope.cp.Group = obj.groupObj;
                     }

                     // Has a group been selected
                     if (obj.groupId && obj.groupId != scope.cp.groupId) {
                        scope.cp.groupId = Number(obj.groupId);
                     }

                     // Organizer only groups // check default group
                     if (scope.cp.viewType == 2) {
                         if (scope.cp.Group && ((scope.cp.Group.createdBy && scope.cp.Group.createdBy.id != app.Member.Detail.id && scope.cp.Group.isAdminRestricted))) {
                           scope.cp.Group = {};
                           scope.cp.groupId = 0;
                        }
                     }

                     // Default Course Text
                     if (obj.defaultText && scope.cp.Group.name == "") {
                        scope.cp.Group.name = obj.defaultText;

                     } else {
                        if (!scope.cp.Group.name || (scope.cp.Group.name == "")) {
                           scope.cp.Group.name = "Choose a Group";
                        }
                     }

                     fetchGroup();
                  }
               }
            }
            , fetchGroup = function () {

               var processGroupDetail = function () {
                  var isOk = true;

               }

               
               if (scope.cp.groupId > 0) {
                  var isFetch = true;
                  if (scope.cp.Group && scope.cp.Group.id && scope.cp.Group.id == scope.cp.groupId) {
                     isFetch = false;
                  }
                  if (isFetch) {
                     scope.cp.dialog.isProcessing = true;
                     ggGroupSearchSvc.search.fetchGroupDetail({ groupId: scope.cp.groupId }).then(function (data) {
                        if (data && data.status == "200") {

                            scope.cp.Group = data.data;


                        }
                     }, function (error) {
                        // nothing
                     }).finally(function () {
                        scope.cp.isLoaded = true;
                        scope.cp.dialog.isProcessing = false;
                     });
                  } else {
                     scope.cp.isLoaded = true;
                     processGroupDetail();
                  }
               } else {
                  scope.cp.isLoaded = true;
                  processGroupDetail();
               }

            }

            ////////////////////////////////////////
            // Watch for Change in Options
            attrs.$observe('options', function () {
               var optStr = attrs.options;
               if (optStr != "") {
                  loadOptions(optStr, true);
               }
            });


         }
      }
   }
}(angular, app));
